// Four-eyes plumbing shared by the client and the governance UI. The header name
// is the API's contract (iam/rbac/four-eyes.decorator.ts APPROVAL_HEADER).
export const APPROVAL_HEADER = "x-approval-id";

/** Lifecycle of a pending four-eyes approval, as the originator's UI tracks it. */
export type ApprovalStatus = "REQUESTED" | "PENDING" | "APPROVED" | "CONSUMED" | "ABANDONED";

export interface PendingApproval {
  /** The approval id, once requested — the value retried as x-approval-id. */
  id?: string;
  action: string;
  resourceId?: string;
  status: ApprovalStatus;
}
